import { base44 } from "@/utils/base44Client";
import { useEffect, useState } from "react";

let currencyCache: any = null;
let currencyPromise: any = null;

export async function loadCurrencies() {
  if (currencyCache) return currencyCache;
  if (currencyPromise) return currencyPromise;
  currencyPromise = base44.entities.Currency.list()
    .then((list) => {
      currencyCache = list;
      return list;
    })
    .catch(() => {
      currencyCache = [];
      return [];
    });
  return currencyPromise;
}

export function useCurrencies() {
  const [currencies, setCurrencies] = useState(currencyCache || []);
  useEffect(() => {
    loadCurrencies().then(setCurrencies);
  }, []);
  return currencies;
}

export function getCurrency(currencies: any[], code: string) {
  return (
    currencies.find((c) => c.code === code) || {
      code,
      symbol: "",
      name: code,
      flag: "",
    }
  );
}

export function formatAmount(amount: any, code: any, currencies: any[]) {
  const c = getCurrency(currencies || [], code);
  const decimals = c.decimals ?? 2;
  const num = Number(amount || 0);
  const formatted = num.toLocaleString("en-US", {
    minimumFractionDigits: decimals > 2 ? 4 : 2,
    maximumFractionDigits: decimals > 2 ? 8 : 2,
  });
  return `${formatted}`;
  // return `${c.symbol || ""}${formatted}`;
}

export function formatNumber(amount: any, decimals = 2) {
  return Number(amount || 0).toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function timeAgo(dateStr: any) {
  if (!dateStr) return "";
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
}

export function genId(prefix = "BF") {
  const n = Math.floor(100000 + Math.random() * 900000);
  return `${prefix}-${n}`;
}

export const POPULAR_CONVERSIONS = [
  { from: "NGN", to: "CNY" },
  { from: "NGN", to: "GHS" },
  { from: "NGN", to: "AED" },
  { from: "NGN", to: "USD" },
  { from: "NGN", to: "USDT" },
  { from: "NGN", to: "BTC" },
  { from: "NGN", to: "BNB" },
  { from: "USDT", to: "NGN" },
  { from: "BTC", to: "NGN" },
  { from: "BNB", to: "NGN" },
  { from: "USDT", to: "CNY" },
  { from: "CNY", to: "NGN" },
];

export const AGENT_STEPS = [
  { key: "offer_selected", label: "Offer selected" },
  { key: "merchant_confirmed", label: "Merchant confirmed" },
  { key: "transaction_created", label: "Transaction created" },
  { key: "payment_pending", label: "Payment pending" },
  { key: "payment_confirmed", label: "Payment confirmed" },
  { key: "settlement", label: "Settlement" },
  { key: "completed", label: "Completed" },
];
